import ES from "./flags/es.svg";
import EN from "./flags/en.svg";

const langs: { [key: string]: { name: string, flag: string } } = {
    'es': {name: 'Español', flag: ES},
    'en': {name: 'English', flag: EN}
}

export default langs;